
import { ActivatedRouteSnapshot } from "@angular/router"
import { AppService } from "app/app.service"
import { CanActivate } from "@angular/router"
import { CanActivateChild } from "@angular/router"
import { Injectable } from "@angular/core"
import { Router } from "@angular/router"
import { RouterStateSnapshot } from "@angular/router"


@Injectable()
export class IsAuthenticatedGuard implements CanActivate, CanActivateChild {

  constructor(
    private appService: AppService,
    private router: Router,
  ) { }

  canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    if (this.appService.user.getValue()) {
      return true
    }
    this.router.navigate(["/login"])
    return false
  }

  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(next, state)
  }
}
